export const REDIRECT_TO_PARAM = 'redirectTo';

// A URL parser removes every tab and newline before reading the URL, so "/\t/evil.com" reaches
// the network as "//evil.com". Validate the string the parser will see, not the one we are given.
const IGNORED_BY_URL_PARSER = /[\t\n\r]/g;

/**
 * Only same-origin absolute paths are accepted, so the verification page can never be turned
 * into an open redirect: absolute URLs, protocol-relative "//host" and their backslash
 * variants are all rejected.
 */
export const isSafeRedirectTarget = (target) =>
    typeof target === 'string' && /^\/(?![/\\])/.test(target.replace(IGNORED_BY_URL_PARSER, ''));

/**
 * Appends the page the member is currently on to a verification URL, so that the end of the flow
 * knows where to send them back. The URL stays relative, the way every caller renders it.
 */
export const withRedirectTo = (verificationUrl, location = window.location) => {
    const target = `${location.pathname}${location.search}${location.hash}`;
    const url = new URL(verificationUrl, location.origin);

    if (!isSafeRedirectTarget(target) || location.pathname === url.pathname) {
        return verificationUrl;
    }

    url.searchParams.set(REDIRECT_TO_PARAM, target);

    return `${url.pathname}${url.search}${url.hash}`;
};

/**
 * Reads back the origin page recorded by withRedirectTo. Returns null when the member reached
 * verification from an untracked touchpoint, so callers can fall back to their default screen.
 */
export const getRedirectTo = (search = window.location.search) => {
    const target = new URLSearchParams(search).get(REDIRECT_TO_PARAM);
    return isSafeRedirectTarget(target) ? target : null;
};
